(() => {
  function init(root) {
    if (root.dataset.readerReady) return;
    root.dataset.readerReady = 'true';
    const prose = root.querySelector('[data-journal-prose]');
    const progress = root.querySelector('[data-journal-progress]');
    const sections = [...root.querySelectorAll('[data-journal-section]')].map(link => ({ link, heading: document.getElementById(decodeURIComponent(link.hash.slice(1))) })).filter(item => item.heading);
    if (!prose) return;
    let scheduled = false;
    function update() {
      scheduled = false;
      if (!root.isConnected) { window.removeEventListener('scroll', request); window.removeEventListener('resize', request); return; }
      const top = prose.getBoundingClientRect().top;
      if (progress) progress.style.transform = `scaleX(${Math.min(1, Math.max(0, (120 - top) / Math.max(1, prose.offsetHeight - window.innerHeight * 0.5)))})`;
      const pageOffset = parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0;
      const headingOffset = sections.length ? parseFloat(getComputedStyle(sections[0].heading).scrollMarginTop) || 0 : 0;
      const readingOffset = Math.max(180, pageOffset + headingOffset + 8);
      let active = sections[0];
      for (const item of sections) if (item.heading.getBoundingClientRect().top <= readingOffset) active = item;
      for (const item of sections) { if (item === active) item.link.setAttribute('aria-current', 'location'); else item.link.removeAttribute('aria-current'); }
    }
    function request() { if (!scheduled) { scheduled = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', request, { passive: true });
    update();
  }
  function scan(scope) { scope.querySelectorAll('[data-journal-reader]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), { once: true }); else scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();
